<template>
  <span v-if="isError" class="is-invalid text-danger">
    {{message}}
  </span>
</template>

<script>
  export default {
    name: 'ErrorMessage',
    props: {
      isError: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>

</style>
